module.exports = __webpack_public_path__ + "static/media/SF-19-A (1).73d6cf50.mp3";